export default __webpack_public_path__ + "static/media/overview_icon_4.132d3f88.png";